var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldBuilding4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.09 3C3.1 3 2.1 4.01 2.1 6.02V22h5.4v-3.75a.749.749 0 1 1 1.5 0V22h5.3V6.02c0-2.01-.99-3.02-2.98-3.02H5.09zm.71 9.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4.95c.41 0 .75.34.75.75s-.34.75-.75.75H5.8zM5.8 9c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4.95c.41 0 .75.34.75.75s-.34.75-.75.75H5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.73 21.251v-3c.95-.31 1.64-1.2 1.64-2.25v-2c0-1.31-1.07-2.38-2.38-2.38-1.31 0-2.38 1.07-2.38 2.38v2c0 1.04.68 1.92 1.61 2.24v3.01H1c-.41 0-.75.34-.75.75s.34.75.75.75h18.93c.02 0 .03.01.05.01.02 0 .03-.01.05-.01H23c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2.27z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldBuilding4);
export default __webpack_public_path__ + "static/media/vuesax-bold-building-4.a263fdbe79fe8d60d02967a8042ac32f.svg";
export { ForwardRef as ReactComponent };